var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      staticClass: "chat-indice-artefatos-completa",
      attrs: { "data-test": "chat-indice-artefatos-completa" }
    },
    _vm._l(_vm.linhas, function(linha) {
      return _c(
        "li",
        { key: linha.identidade, staticClass: "px-2" },
        [
          _c("ArtefatoPreviewCard", {
            attrs: {
              mini: "",
              identidade: linha.identidade,
              "store-module": _vm.storeModule,
              titulo: linha.titulo,
              icone: linha.icone,
              subtitulo: linha.subtitulo,
              tempo: linha.tempo
            },
            on: {
              abrir: function($event) {
                return _vm.abrir(linha)
              },
              fechar: _vm.fechar
            }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }